import PropTypes from 'prop-types';
import React from 'react';
import PackageAddOnItem from './PackageAddOnItem';
import formatTimeString from '../../utils/formatTimeString';
import modMax from '../../utils/modMax';
import modMin from '../../utils/modMin';
import { packagePrice, packagePricePreTax } from '../../utils/packagePrice';
import PriceSum from '../common/PriceSum';
import itemLimit from '../../utils/itemLimit';

export const PackageAddOns = ({
  pkg,
  num,
  value,
  addOns,
  disabled,
  onChange,
  maxMet,
  minMet,
  salePkg,
  sale,
  config,
  autoAdded
}) => {
  return (
    <div className="swformfield-tktpackage-lineitem">
      <div className="swformfield-tktpackage-lineitem__summary">
        <div className="swformfield-tktpackage-lineitem__summary-header">
          {pkg.descrip}
          {sale && salePkg && salePkg.time && (
            <span>
              &nbsp;@&nbsp;
              {formatTimeString(sale.day, salePkg.time)}
            </span>
          )}
          <span className="swformfield-tktpackage-lineitem__summary-header-quantity">
            &nbsp;({num})
          </span>
        </div>
        <div className="swformfield-swformfield-tktpackage-lineitem__amount-total">
          {config.taxInclusive ? (
            <PriceSum price={packagePrice(pkg, sale)} count={num} />
          ) : (
            <PriceSum price={packagePricePreTax(pkg, sale)} count={num} />
          )}
        </div>
      </div>

      {addOns != null && addOns.length > 0 && (
        <div className="swformfield-tktpackage-lineitem__addons-header">
          <div className="swformfield-tktpackage-lineitem__addons-header__header">
            Available Addons
          </div>
        </div>
      )}

      <div className="swformfield-tktpackage-lineitem__addons-list">
        {(addOns == null || addOns.length < 1) && (
          <div className="swformfield-tktpackage-lineitem__addon">
            <div className="swformfield-tktpackage-lineitem__addon--summary">
              No addons available
            </div>
          </div>
        )}

        {addOns.map(addOn => {
          return (
            <PackageAddOnItem
              key={addOn.item_id}
              addOn={addOn}
              qty={value[addOn.item_id] ? value[addOn.item_id].qty : 0}
              minQty={autoAdded ? modMin(pkg) : 0}
              maxQty={modMax(pkg)}
              time={value[addOn.item_id] ? value[addOn.item_id].time : ''}
              limit={itemLimit(pkg, sale, config)}
              disabled={disabled}
              onQtyChange={qty => {
                const newValue = {
                  ...value,
                  [addOn.item_id]: {
                    qty,
                    ...(value[addOn.item_id] &&
                      (value[addOn.item_id].time && {
                        time: value[addOn.item_id].time
                      }))
                  }
                };
                if (qty == 0) {
                  delete newValue[addOn.item_id];
                }
                onChange(newValue);
              }}
              onTimeChange={time => {
                const newValue = {
                  ...value,
                  [addOn.item_id]: {
                    time,
                    ...(value[addOn.item_id] &&
                      value[addOn.item_id].qty && {
                        qty: value[addOn.item_id].qty
                      })
                  }
                };
                onChange(newValue);
              }}
              maxMet={maxMet}
              minMet={minMet}
              sale={sale}
              config={config}
              autoAdded={autoAdded}
            />
          );
        })}
      </div>
    </div>
  );
};

PackageAddOns.propTypes = {
  pkg: PropTypes.object,
  num: PropTypes.number,
  disabled: PropTypes.bool,
  addOns: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  maxMet: PropTypes.bool,
  minMet: PropTypes.bool,
  salePkg: PropTypes.object,
  sale: PropTypes.object,
  config: PropTypes.object,
  autoAdded: PropTypes.bool
};
